/*
    © 2023 EcomGraduates.com
    https://www.ecomgraduates.com
*/

// Refresh cart contents (offcanvas cart, cart page, count badges, etc)
window.refreshCartContents = async (response) => {
  console.log(response)

  const offcanvasCart = document.querySelector('#offcanvas-cart')

  offcanvasCart?.classList.add('loading')

  const newResponse = await fetch(window.location.href)
  const text = await newResponse.text()
  const newDocument = new DOMParser().parseFromString(text, 'text/html')

  offcanvasCart
    ?.querySelector('.offcanvas-body')
    .replaceWith(newDocument.querySelector('#offcanvas-cart .offcanvas-body'))
  offcanvasCart
    ?.querySelector('.offcanvas-footer')
    .replaceWith(newDocument.querySelector('#offcanvas-cart .offcanvas-footer'))

  document.querySelector('#cart')?.replaceWith(newDocument.querySelector('#cart'))

  document.querySelectorAll('.cart-count-badge').forEach((badge) => {
    badge.textContent = newDocument.querySelector('.cart-count-badge').textContent
    badge.removeAttribute('hidden')
  })

  offcanvasCart?.classList.remove('loading')

  window.dispatchEvent(new Event('updated.ecomify.cart'))

  if (response.ok) {
    if (response.url.includes('add.js')) {
      offcanvasCart?.querySelector('#offcanvas-cart-alert-add').removeAttribute('hidden')

      const data = await response.json()

      if (data.items?.length > 1) {
        const elemAlertItemsAdded = offcanvasCart?.querySelector('#offcanvas-cart-alert-add [data-alert-items-added]')

        elemAlertItemsAdded.textContent = elemAlertItemsAdded.textContent.replace('[count]', data.items.length)
        elemAlertItemsAdded.removeAttribute('hidden')
      } else {
        offcanvasCart?.querySelector('#offcanvas-cart-alert-add [data-alert-item-added]').removeAttribute('hidden')
      }
    } else {
      offcanvasCart?.querySelector('#offcanvas-cart-alert-updated').removeAttribute('hidden')
    }
  } else {
    const data = await response.json()
    const alert = document.querySelector('#offcanvas-cart-alert-error')
    alert.querySelector('span').textContent = `${data.message} - ${data.description}`
    alert.removeAttribute('hidden')
  }
}

// Quantity Inputs
window.onChangeCartQty = async (input) => {
  const response = await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: input.dataset.lineItemKey,
      quantity: input.value,
    }),
  })
  window.refreshCartContents(response)
}

// Remove Buttons
window.onRemoveCartItem = async (btn) => {
  const response = await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: btn.dataset.lineItemKey,
      quantity: 0,
    }),
  })
  window.refreshCartContents(response)
}

// Cart note - Show button on keydown
window.showNoteButton = (input) => {
  input.closest('#cart-note').querySelector('button').removeAttribute('hidden')
}

// Cart note - Save note via ajax
window.onSaveCartNote = async (btn) => {
  btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status" style="width: 1rem; height: 1rem">
            <span class="visually-hidden">Loading...</span>
        </div>
    `

  const note = btn.closest('#cart-note').querySelector('[name="note"]').value

  await fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ note }),
  })

  btn.innerHTML = `✓ <span class="visually-hidden">${btn.dataset.textNoteSaved}</span>`

  setTimeout(() => {
    btn.innerHTML = btn.dataset.textBtnSave
  }, 4000)
}

// Checkout button - indicate loading on click
window.onClickCheckoutBtn = (btn) => {
  btn.style.height = btn.clientHeight + 'px'
  btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status" style="width: 1.2rem; height: 1.2rem">
            <span class="visually-hidden">Loading...</span>
        </div>
    `
}

// Cart Goal - Animate width
const initCartGoal = () => {
  const progressBar = document.querySelector('#cart-goal .progress-bar')
  if (progressBar) {
    setTimeout(() => {
      progressBar.style.width = progressBar.dataset.width
    }, 250)
  }
}
initCartGoal()

window.addEventListener('updated.ecomify.cart', () => {
  initCartGoal()
})

// Summary card on the cart page - sticky on desktop
const initStickySummaryCard = () => {
  const card = document.querySelector('#cart-summary')

  if (!card) return

  if (window.matchMedia('max-width: 991px').matches) return

  const navbarHeight = document.querySelector('[id*="__navbar"].sticky-top').clientHeight || 0
  card.style.position = 'sticky'
  card.style.top = `${navbarHeight + 20}px`
}
initStickySummaryCard()

window.addEventListener('updated.ecomify.cart', () => {
  initStickySummaryCard()
})

window.onClickOpenAltCart = (btn) => {
  window.HS_SLIDE_CART_OPEN()
  const checkout = document.querySelector('.hs-checkout-purchase')
  const newButton = checkout.cloneNode(true)
  checkout.parentNode.replaceChild(newButton, checkout)
  newButton.addEventListener('click', (e) => {
    window.location.href = '/checkout'
  })
}
